import { createContext } from 'react';

const editionContext = createContext();

export default editionContext;
